module.exports = __webpack_public_path__ + "img/cart.895681a9.svg";